import { Injectable } from '@angular/core';
import { get } from 'aws-amplify/api';
import { getUrl } from 'aws-amplify/storage';

@Injectable({
    providedIn: 'root'
})
export class ProfilePictureService {

    async getProfilePicture(s3Key: string): Promise<string | null> {
        if (!s3Key) return null;

        try {
            const restOperation = get({
                apiName: 'profilePicture',
                path: '/profile',
                options: {
                    queryParams: { key: s3Key }
                }
            });

            const response = await restOperation.response;

            // Lambda returns base64 encoded body directly as text
            const base64Data = await response.body.text();

            // Decode base64 to binary
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'image/jpeg' });

            return URL.createObjectURL(blob);
        } catch {
            // Missing profile pictures are expected - return null silently
            return null;
        }
    }


    async getProfilePictureUrlSigned(s3Key: string): Promise<string | null> {
        if (!s3Key) return null;

        try {
            const restOperation = get({
                apiName: 'profilePicture',
                path: '/profile',
                options: {
                    queryParams: { key: s3Key, type: 'url' }
                }
            });

            const response = await restOperation.response;
            const data = await response.body.json();

            return (data as unknown as { url: string }).url;
        } catch (error) {
            console.error('Error fetching signed URL from Lambda proxy for', s3Key, error);
            return null;
        }
    }
}
